module.exports = __webpack_public_path__ + "img/pl_action.6366ec1a.png";